import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Button, TextField, Skeleton } from '@mui/material';
import vendorService from 'api/vendorService';
import { gridSpacing } from 'store/constant';
import { toast } from 'react-toastify';

const VendorBio = ({ data, isLoading }) => {
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        try {
            setLoading(true);
            await vendorService.updateVendor({ description });
            toast.success('Description updated successfully!');
        } catch (err) {
            toast.error('Failed to update bio');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (data?.vendor) {
            setDescription(data.vendor.description || '');
        }
    }, [data]);

    if (isLoading) {
        return (
            <Grid container spacing={gridSpacing} paddingX={5} pt={3}>
                <Grid item md={5}>
                    <Skeleton variant="text" width={200} height={40} />
                    <Skeleton variant="text" width={300} height={20} />
                </Grid>
                <Grid item md={7}>
                    <Skeleton variant="rectangular" height={120} sx={{ mb: 2, borderRadius: 2 }} />
                    <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 2 }} />
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={gridSpacing} paddingX={5} pt={3}>
            <Grid item md={5}>
                <Typography fontWeight="bold" fontSize={20}>
                    Business Description
                </Typography>
                <Typography color="grey" fontSize={14}>
                    Provide a brief description of your business below.
                </Typography>
            </Grid>
            <Grid item md={2}>
                -
            </Grid>
            <Grid item md={5}>
                <TextField
                    fullWidth
                    label="About Your Business"
                    multiline
                    minRows={8}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    sx={{ mb: 2 }}
                />

                <Button variant="contained" color="primary" onClick={handleSave} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </Button>
            </Grid>
        </Grid>
    );
};

VendorBio.propTypes = {
    data: PropTypes.shape({
        vendor: PropTypes.shape({
            description: PropTypes.string
        })
    }),
    isLoading: PropTypes.bool
};

export default VendorBio;
